/* eslint-disable import/prefer-default-export */
const scrollToError = (parentId: string, spanClassName = 'text-error') => {
  setTimeout(() => {
    const parent = document.getElementById(parentId);
    const errors = [];
    if (parent) {
      const allElements = parent.getElementsByTagName('*');
      for (let i = 0; i < allElements.length; i += 1) {
        const classNameStr = typeof allElements[i].className === 'string' ? allElements[i].className : '';
        if (classNameStr && classNameStr.indexOf(spanClassName) !== -1) {
          errors.push(allElements[i]);
        }
      }
    }

    if (errors.length > 0) {
      errors[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  }, 0);
};

export {
  scrollToError,
};
